/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IMediaGalleryViewProps } from './lobas-media-gallery';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { CarouselProps, MediaGallery, Modal, Props3dViewer } = props;

    return (
        <Module {...MediaGallery}>
            <Node {...CarouselProps} />
            {Modal}
            {Props3dViewer}
        </Module>
    );
};

export default MediaGalleryView;
